module.exports = __webpack_public_path__ + "img/6.85e974ba.jpg";